<div class="widget">
  {{examTemplate.name}}
  
  <!--<div class="flex">
    <i-tabler name="square-rounded-check"></i-tabler>
    <span>2x absolviert</span>
  </div>-->

  <i-tabler name="circle-arrow-right" class="open-arrow"></i-tabler>
</div>